/***
 * DIBS FlexWin (aquired by NETS)
 * @doc https://tech.dibspayment.com/D2/Hosted/Input_parameters/Standard
 */

export default function dibsForm() {
    return {
        template: require("./template.html"),
        scope: {
            bookingId: "<",
            amount: "<",
            bookingPeriods: "<",
        },

        controller: function ($scope, ENV, BookingPeriods) {
            $scope.debug = true;

            const prices = BookingPeriods.updatePrices($scope.bookingPeriods);

            // http://localhost:8080/checkout/payment-complete?currencynumber=208&authkey=6762ea97bce02ce15ffea36dce9a6477&amount=100&accepturl=http:%2F%2Flocalhost:8080%2Fcheckout%2Fpayment-complete%2F&test=1&orderid=1482212&merchant=90234252&flexwin_cardlogosize=3&statuscode=5&approvalcode=123456&transact=2895223819&uniqueoid=yes&cardnomask=XXXXXXXXXXXX0000&capturenow=yes&currency=208&md5key=e4a7e3c54857d152a226456535676fa0&callbackurl=https:%2F%2Fprojektbookbyen.dk%2Fweb%2Fapi%2FBooking%2FHandlePaymentResult%2F&currencyalpha=DKK&cardprefix=471110&paytype=VISA

            // http://localhost:8080/checkout/payment-complete?
            // currencynumber=208
            // authkey=fff02efc55964bd9b83346127d81e41f
            // amount=100
            // accepturl=
            // http://localhost:8080/checkout/payment-complete/
            // // test=1
            // // orderid=1482162
            // // merchant=90247902
            // // acquirer=TEST
            // // flexwin_cardlogosize=3
            // // statuscode=5
            // // approvalcode=123456
            // // transact=2894792865
            // // uniqueoid=yes
            // // cardnomask=XXXXXXXXXXXX0000
            // // flexwin_help=1
            // // capturenow=yes
            // // currency=208
            // // callbackurl=https://projektbookbyen.dk/web/api/Booking/HandlePaymentResult/
            // // // currencyalpha=DKK
            // // cardprefix=457110
            // //  paytype=V-DK

            // /**
            //  * GET /payments/gateways/nets/
            //  *
            //  * @param {string} merchant
            //  * @param {string} bookingId
            //  * @param {string} currency
            //  * @param {string} amount
            //  *
            //  * @return {string}
            //  */
            // const calcMd5Key = (merchant, orderid, currency, amount) => {
            //     const k1 = ""; // NETS D2 private key
            //     const k2 = ""; // NETS D2 private key

            //     const params = `merchant=${merchant}&orderid=${orderid}&currency=${currency}&amount=${amount}`;

            //     const md5key = md5.createHash(k2 + md5.createHash(k1 + params));

            //     return md5key;
            // };

            const nets = {
                merchant: "90234252", // 90247902
                orderid: $scope.bookingId,
                currency: 208, // 208 = DKK // ISO_4217
                amount: prices.totalPrice * 100,
                capturenow: "yes",
                uniqueoid: "yes",
                callbackurl: ENV.apiLegacy + "/Booking/HandlePaymentResult/", // callbackUrl - Legacy API
                accepturl: ENV.domain + "/checkout/payment-complete/", //  acceptUrl -> return to app
                // accepturl: ENV.apiLegacy + "/Booking/PaymentComplete/", //  acceptUrl -> return to app
            };

            /**
             * Add test mode to projektbookbyen.dk
             */
            if (ENV.payment.gateway.purpose == "test") {
                nets.test = 1;
            }

            // eslint-disable-next-line no-undef
            nets.md5key = calcMd5Key(
                nets.merchant,
                nets.orderid,
                nets.currency,
                nets.amount
            );

            $scope.formInputs = nets;

            /***
             * display link to test cards ?
             */

            $scope.isPaymentGatewayInTestMode = ENV.payment.enabled
                ? ENV.payment.gateway.purpose == "test"
                : false;

            // TO DO ::: LOW ::: Flexwin skift fra DIBS til NETS logo ??

            // $scope.dibsForm = {
            //     Message: "",
            //     URL: {
            //         Method: "POST",
            //         URL:
            //             "https://payment.architrade.com/paymentweb/start.action",
            //     },
            //     Success: true,
            //     AlreadyPayed: false,
            // };

            // .then((res) => {});

            /**
             * Legacy (dummy)
             * "TO DO :: using dummy paymentUrl : What if they allready payed ?"
             */

            //Activate the booking button!!
            var paymentNowEventListener = $scope.$on(
                "payment-now-broadcast",
                function () {
                    // avail parma : $events

                    $("#NETS_Payment").submit();
                }
            );
            $scope.$on("$destroy", paymentNowEventListener);
        },
    };
}
